module.exports = __webpack_public_path__ + "img/chart.820c0006.svg";